<template>
  <div>
    <v-list-item>
      <v-list-item-subtitle
        >{{ $t("components.thg.ThgChargingStationProofChipList.proof") }}
        <thg-charging-station-help-dialog
          :helpTextTitle="$t('components.thg.ThgVehicleTable.help.title')"
          :helpText="$t('components.thg.ThgChargingStationProofChipList.addProofText')"
        ></thg-charging-station-help-dialog>
      </v-list-item-subtitle>
    </v-list-item>
    <!-- Upload button -->
    <v-list-item style="min-height: auto">
      <v-list-item-content class="pt-0 pb-0">
        <v-btn dense small depressed dark :color="partnerColor.primary" v-on:click="openManageFilesMenu">{{
          $t("components.thg.ThgChargingStationProofChipList.upload")
        }}</v-btn>
      </v-list-item-content>
    </v-list-item>

    <div v-if="files && files.length">
      <v-list>
        <v-list-item v-for="file in files" :key="file.id">
          <v-chip v-on:click="downloadFile(file)" color="primary">{{ file.originalName }}</v-chip>
        </v-list-item>
      </v-list>
    </div>

    <v-dialog persistent v-model="dialog" width="600px">
      <v-card flat>
        <v-card-title :style="partnerColor.gradientStyle">
          <span :style="`color:white`">{{ $t("components.thg.ThgChargingStationProof.uploadProofTitle") }}</span>
          <v-spacer />
          <v-btn :color="partnerColor.primaryDarken_3" icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <thg-charging-station-proof-document-table
            :files="displayFiles"
            :refs="refs"
            v-on:file-removed="onFileRemove"
          />
        </v-card-text>
        <v-card-text>
          <thg-charging-station-proof
            v-on:file-change="onFileUpload"
            :uploadedFiles="files"
          ></thg-charging-station-proof>
        </v-card-text>

        <v-card-actions class="pl-6 pr-6">
          <v-btn
            class="mb-2"
            dense
            small
            depressed
            :color="partnerColor.primary"
            dark
            @click="updateChargingStationWithProofs"
          >
            {{ $t("components.thg.ThgChargingStationProofChipList.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { PartnerColor } from "@/lib/partnerColor";
import {
  ThgChargingStationDocumentTypeDtoGen,
  ThgChargingStationProofDocumentDtoGen
} from "@/services/thg/v1/data-contracts";
import { saveAs } from "file-saver";
import { Component, Prop, Vue } from "vue-property-decorator";
import ThgChargingStationHelpDialog from "./ThgChargingStationHelpDialog.vue";
import ThgChargingStationProof from "./ThgChargingStationProof.vue";
import ThgChargingStationProofDocumentTable from "./ThgChargingStationProofDocumentTable.vue";

@Component({
  components: {
    ThgChargingStationProof,
    ThgChargingStationProofDocumentTable,
    ThgChargingStationHelpDialog
  }
})
export default class ThgChargingStationProofChipList extends Vue {
  @Prop()
  files!: ThgChargingStationProofDocumentDtoGen[];

  @Prop()
  refs!: ThgChargingStationDocumentTypeDtoGen[];

  showMenu = false;
  dialog = false;
  /** Files to display in the document table. Add to files only after save. */
  displayFiles: ThgChargingStationProofDocumentDtoGen[] = [];
  partnerColor = new PartnerColor();

  mounted() {
    if (this.files) {
      this.displayFiles.push(...this.files);
    }
  }

  openManageFilesMenu() {
    this.dialog = true;
  }

  onFileUpload(file: ThgChargingStationProofDocumentDtoGen) {
    this.displayFiles.push(file);
  }

  onFileRemove(file: ThgChargingStationProofDocumentDtoGen) {
    const indexOfFile = this.displayFiles.findIndex((uploadedFile) => uploadedFile.id === file.id);

    if (indexOfFile !== -1) {
      this.displayFiles.splice(indexOfFile, 1);
    }
  }

  downloadFile(file: ThgChargingStationProofDocumentDtoGen) {
    saveAs(file.url, file.name);
  }

  updateChargingStationWithProofs() {
    this.$emit("proof-update", this.displayFiles);
    this.dialog = false;
  }

  close() {
    this.dialog = false;
  }
}
</script>
